<template>
    <div class="modal-backdrop" @click="this.close">
      <div class="modal">
        <div class="modal-body">
          <div id="y1" class="yy"></div>
          <div id="y2" class="yy"></div>
          <div id="y3" class="yy"></div>
          <div id="y4" class="yy"></div>
          <div id="y5" class="yy"></div>
          <div id="y6" class="yy"></div>
          <div id="y7" class="yy"></div>
          <div id="y8" class="yy"></div>
          <div id="y9" class="yy"></div>
          <div id="y10" class="yy"></div>
          <div id="y11" class="yy"></div>
          <div id="y12" class="yy"></div>
          <div id="y13" class="yy"></div>
          <div id="y14" class="yy"></div>
          <div id="y15" class="yy"></div>
          <div id="y16" class="yy"></div>
          <div id="y17" class="yy"></div>
          <div id="y18" class="yy"></div>
          <div id="y19" class="yy"></div>
          <div id="y20" class="yy"></div>
        </div>
      </div>
    </div>
</template>

<script>
  import chatDataCenter from "../../jsSdk/chatDataCenter";
    export default {
        name: "voiceModal",
        methods: {
          // 关闭按钮事件
          close() {
            this.$emit("on-cancel");
          }
        }
    }
</script>

<style>
  .modal-backdrop {
    position: fixed;
    top: calc((100% - 45px) / 2);
    right: 0;
    bottom: 0;
    left: calc((100% - 62%) / 2);
    background-color: rgba(0, 0, 0, 0.5);
    width: 62%;
    height: 45px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    z-index: 99999999;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    background-color: #95ec69;
    border-radius: 16px;
  }
  .modal {
    background-color: #95ec69;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    border-radius: 16px;
    width: 100%;
    /*user-select: none;*/
    padding: 10px;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  .modal-body {
    position: relative;
    /*padding: 20px;*/
    text-align: center;
    height: 25px;
    border-radius: 16px;
  }
  /*.modal-body:before {*/
  /*  content: " ";*/
  /*  position: absolute;*/
  /*  width: 0;*/
  /*  height: 0;*/
  /*  left: 46%;*/
  /*  top: 60px;*/
  /*  border: 12px solid;*/
  /*  border-color: #95ec69 transparent transparent transparent;*/
  /*}*/
  @keyframes yuying1 {
    0% {
      height: 0%;
    }
    20% {
      height: 50%;
    }
    50% {
      height: 100%;
    }
    80% {
      height: 50%;
    }
    100% {
      height: 0%;
    }
  }

  #y1 {
    animation: yuying1 1.1s infinite 0.1s;
    -webkit-animation: yuying1 1.1s infinite 0.1s;
  }
  #y2 {
    animation: yuying1 1.1s infinite 0.2s;
    -webkit-animation: yuying1 1.1s infinite 0.2s;
  }
  #y3 {
    animation: yuying1 1.1s infinite 0.3s;
    -webkit-animation: yuying1 1.1s infinite 0.3s;
  }
  #y4 {
    animation: yuying1 1.1s infinite 0.4s;
    -webkit-animation: yuying1 1.1s infinite 0.4s;
  }
  #y5 {
    animation: yuying1 1.1s infinite 0.5s;
    -webkit-animation: yuying1 1.1s infinite 0.5s;
  }
  #y6 {
    animation: yuying1 1.1s infinite 0.6s;
    -webkit-animation: yuying1 1.1s infinite 0.6s;
  }
  #y7 {
    animation: yuying1 1.1s infinite 0.7s;
    -webkit-animation: yuying1 1.1s infinite 0.7s;
  }
  #y8 {
    animation: yuying1 1.1s infinite 0.8s;
    -webkit-animation: yuying1 1.1s infinite 0.8s;
  }
  #y9 {
    animation: yuying1 1.1s infinite 0.9s;
    -webkit-animation: yuying1 1.1s infinite 0.9s;
  }
  #y10 {
    animation: yuying1 1.1s infinite 1s;
    -webkit-animation: yuying1 1.1s infinite 1s;
  }
  #y11 {
    animation: yuying1 1.1s infinite 1s;
    -webkit-animation: yuying1 1.1s infinite 1s;
  }
  #y12 {
    animation: yuying1 1.1s infinite 0.9s;
    -webkit-animation: yuying1 1.1s infinite 0.9s;
  }
  #y13 {
    animation: yuying1 1.1s infinite 0.8s;
    -webkit-animation: yuying1 1.1s infinite 0.8s;
  }
  #y14 {
    animation: yuying1 1.1s infinite 0.7s;
    -webkit-animation: yuying1 1.1s infinite 0.7s;
  }
  #y15 {
    animation: yuying1 1.1s infinite 0.6s;
    -webkit-animation: yuying1 1.1s infinite 0.6s;
  }
  #y16 {
    animation: yuying1 1.1s infinite 0.5s;
    -webkit-animation: yuying1 1.1s infinite 0.5s;
  }
  #y17 {
    animation: yuying1 1.1s infinite 0.4s;
    -webkit-animation: yuying1 1.1s infinite 0.4s;
  }
  #y18 {
    animation: yuying1 1.1s infinite 0.3s;
    -webkit-animation: yuying1 1.1s infinite 0.3s;
  }
  #y19 {
    animation: yuying1 1.1s infinite 0.2s;
    -webkit-animation: yuying1 1.1s infinite 0.2s;
  }
  #y20 {
    animation: yuying1 1.1s infinite 0.1s;
    -webkit-animation: yuying1 1.1s infinite 0.1s;
  }

  .yy {
    width: 3px;
    height: 100%;
    margin-left: 3px;
    border-radius: 50px;
    background: linear-gradient(to bottom, #2D8EF2 0%,#4D67D6 100%);
    vertical-align: middle;
    display: inline-block;
  }
</style>
